

export const selectSearchTableColumns = [
  {
    Header: 'Nombre',
    accessor: 'name',
  },
  {
    Header: 'Tipo de encuesta',
    accessor: 'survey_type',
  }
];
